import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Logo from '../images/logo2.png'

export default function Footer() {
    return (
  
      // <FooterWrap>
        <div>
      <div  style={{backgroundColor:"rgb(38 3 39) ",height:"170px"}}>
        <div className="flex justify-around w-full pt-3" >
                <div className="md:ml-44  md:block hidden ">
                <img src={Logo} className="" alt="logo"/>   
                </div>    
                  <div className="" > 
            
                        <ul >
                          <li><Link style={{color:'white',letterSpacing:"1px"}}>Privacy Policy</Link></li>
                          <li><Link style={{color:'white',letterSpacing:"1px"}}>Terms & Conditions</Link></li>
                          <li><Link style={{color:'white',letterSpacing:"1px"}}>Shipping Policy</Link></li>
                          <li><Link style={{color:'white',letterSpacing:"1px"}} to="/about">About Us</Link></li>
                        </ul>
                        </div>
                  <div className="text-white"  > 
                <h4 className='text-white' >Contact Us</h4>
                <p >customercare@maalola.com<br/>+91 8296099974</p>
                <div > 
                <p >Luova gifting,<br/> c/o Maalola shared services </p>
                </div>
                </div>
        </div>
            </div>

          <div style={{backgroundColor:"rgb(24 2 25)"}}>
              
            <p style={{color:"white", margin:0, padding:"0.5rem 0", textAlign:"center", }}>Copyright &#169; 2021 Luova.</p> 
      
          </div>
          </div>
    )
}



// const FooterWrap = styled.div`

// /* position: absolute; */
// bottom:0;
// left:0;
// width:100%;

// `